export interface Settings {
  big: boolean
  light: boolean
  sound: boolean
  haptic: boolean
}

const STORAGE_KEY = 'wb-settings'

const DEFAULT_SETTINGS: Settings = {
  big: false,
  light: false,
  sound: true,
  haptic: true
}

export function getSettings(): Settings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return { ...DEFAULT_SETTINGS }
    return { ...DEFAULT_SETTINGS, ...JSON.parse(raw) }
  } catch {
    return { ...DEFAULT_SETTINGS }
  }
}

export function setSettings(settings: Settings): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings))
  } catch {
    // Indstillinger må ikke blokere appen
  }
}

export function updateSetting<K extends keyof Settings>(key: K, value: Settings[K]): Settings {
  const next = { ...getSettings(), [key]: value }
  setSettings(next)
  applySettings()
  return next
}

export function applySettings(): void {
  try {
    const settings = getSettings()
    document.body.classList.toggle('big', settings.big)
    document.body.classList.toggle('light', settings.light)
  } catch {
    // Ingen document i denne kontekst (fx tests)
  }
}
